import '../../app.es6';
import angular from 'angular';
import moment from '../../../node_modules/moment/moment.js';

const COMPONENT_NAME = 'personalCard';

class PersonalCardController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $timeout, commonApiFactory, commonFactory, Const
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$timeout = $timeout;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;

    this.hasMessage = false;
    this.isCoach = localStorage.getItem(this.Const.LSAPP_ROLE) !== this.Const.LSAPP_ROLE_MEMBER;

    this.isCreateMode = false;
    this.isUpdateMode = false;
    this.isDialogOpened = false;

    // 表示名 表示性別 敬称 テーマ対象
    this.displayName = '';
    this.displayGender = '';
    this.honorificTitle = '';
    this.targetId = '';

    // 表示メッセージ
    this.message = '';
    this.initMessage = '';
    this.displayYear = '';
    this.displayMonth = '';
    this.displayDate = '';

    // 表示メッセージ(一時保存用)
    this.hasDraftMessage = false;
    this.draftMessage = '';

    // テーマ設定
    this.themeMinHeight = 60;
    this.themeMaxHeight = 80;
    this.isOverflow = false;
    this.isAllView = false;
    this.readMoreLabel = this.Const.READ_MORE_LABEL.open;
    this.draftMinHeight = 60;
    this.draftMaxHeight = 80;
    this.isDraftOverflow = false;
    this.isDraftAllView = false;
    this.draftReadMoreLabel = this.Const.READ_MORE_LABEL.open;

    // validateメッセージ表示判定
    this.validationForPersonalCard = {
      isEmpty: false,
      isOverLength: false,
      isProhibitionChars: false
    };

    if (this.isCoach) {
      if (this.coachView) {
        // 生徒の情報を参照
        this.displayName = this.$sessionStorage[this.Const.SSAPP_USER_NAME];
        this.displayGender = this.$sessionStorage[this.Const.SSAPP_GENDER];
        this.honorificTitle = 'さん';
        this.targetId = this.$sessionStorage[this.Const.SSAPP_MEMBER_ID];
      } else {
        // 自身の情報を参照
        this.displayName = this.$sessionStorage[this.Const.SSAPP_COACH_NAME];
        this.displayGender = this.$sessionStorage[this.Const.SSAPP_COACH_GENDER];
        this.honorificTitle = 'コーチ';
        this.targetId = '';
      }
    } else {
      // 生徒自身の情報を参照
      this.displayName = this.$sessionStorage[this.Const.SSAPP_USER_NAME];
      this.displayGender = this.$sessionStorage[this.Const.SSAPP_GENDER];
      this.honorificTitle = 'さん';
      this.targetId = '';
    }

    // genderのimagePath取得
    switch (this.displayGender) {
      case this.Const.GENDER_TYPE.male:
        this.displayImagePath = 'res/st_top/common_icon_user_male.png';
        break;
      case this.Const.GENDER_TYPE.female:
        this.displayImagePath = 'res/st_top/common_icon_user_female.png';
        break;
      default:
        this.displayImagePath = 'res/st_top/common_icon_user_default.png';
    }

    // 整合性チェック
    if (!this.showTheme) {
      // テーマ非表示の場合、編集不可&データ取得不要
      this.editMode = false;
      this.targetId = '';
    }
    // 編集可能なのにコーチではない
    if (this.editMode && !this.isCoach) {
      // 編集不可に
      this.editMode = false;
    }

    if (this.targetId) {
      this.getMemberIdMessages();
    } else {
      if (!this.isCoach) {
        this.getMeMessages();
      }
    }

    this.initThemeView();
    this.initDraftView();

    PersonalCardController.$inject = [
      '$scope', '$sessionStorage', '$timeout', 'commonApiFactory', 'commonFactory', 'Const'
    ];
  }

  initThemeView () {
    /*
      min-heightは表示が3行になる高さに指定。
      max-heightは表示が4行になる高さに指定。
      表示情報がmin-heightを下回ればmin-heightが適用。上回ればmax-heightが適用。
      overflow:hiddenを適用しているのでそれ以上は表示されない。
      scrollHeightは非表示を含めた実値のためそれを上回る高さの場合は
    */
    this.$timeout(() => {
      if (document.getElementById('viewTheme')) {
        if (this.themeViewAll) {
          this.readMore();
        } else {
          let sHeight = document.getElementById('viewTheme').scrollHeight;
          this.isOverflow = sHeight > this.themeMaxHeight;
          if (this.isOverflow) {
            // themeMaxHeightを底上げしたのは半透明部分
            this.themeMaxHeight = 120;
          }
          this.readMoreLabel = this.isOverflow ? this.Const.READ_MORE_LABEL.open : this.Const.READ_MORE_LABEL.close;
        }
      }
    }, 3000);
  }

  initDraftView () {
    this.$timeout(() => {
      if (document.getElementById('viewDraft')) {
        this.draftReadMore();
      }
    }, 3000);
  }

  readMore () {
    this.isAllView = !this.isAllView;
    if (this.isAllView) {
      this.themeMaxHeight = document.getElementById('viewTheme').scrollHeight;
      this.readMoreLabel = this.Const.READ_MORE_LABEL.close;
      // オープン時にリンクを削除対応。以下を削除するとcloseリンク出力
      this.isOverflow = false;
    } else {
      this.themeMaxHeight = 80;
      this.readMoreLabel = this.Const.READ_MORE_LABEL.open;
    }
  }

  draftReadMore () {
    this.isDraftAllView = !this.isDraftAllView;
    if (this.isDraftAllView) {
      this.draftMaxHeight = document.getElementById('viewDraft').scrollHeight;
      this.draftReadMoreLabel = this.Const.READ_MORE_LABEL.close;
      // オープン時にリンクを削除対応。以下を削除するとcloseリンク出力
      this.isDraftOverflow = false;
    } else {
      this.draftMaxHeight = 80;
      this.draftReadMoreLabel = this.Const.READ_MORE_LABEL.open;
    }
  }

  getMemberIdMessages () {
    let getMembersMemberIdMessagesParams = {
      memberId: this.targetId,
      type: 1
    };
    this.commonApiFactory.getMembersMemberIdMessages(getMembersMemberIdMessagesParams)
    .then((result) => {
      this.hasMessage = false;
      if (result.length > 0) {
        result.reverse();
        result = result.filter((element) => {
          if (element['data']['isUnpublished']) {
            this.hasDraftMessage = true;
            this.draftMessageId = element['id'];
            this.draftMessage = element['data']['message'];
          }
          return !element['data']['isUnpublished'];
        });
        // 一時保存テーマを除外したresultからさらに最新のテーマを取得する
        if (result.length > 0) {
          let message = result.shift();
          this.hasMessage = true;
          this.messageId = message['id'];
          this.message = message['data']['message'];
          this.initMessage = this.message;
          this.displayYear = moment(message['createdAt']).format('YYYY');
          this.displayMonth = moment(message['createdAt']).format('MM');
          this.displayDate = moment(message['createdAt']).format('DD');
        }
      }
      this.$scope.$apply();
    })
    .catch((error) => {
      // エラー発生時、テーマを非表示に
      this.showTheme = false;
      this.$scope.$apply();
      console.error(error);
    });
  }

  getMeMessages () {
    let getMembersMeMessagesParams = {
      type: 1
    };
    this.commonApiFactory.getMembersMeMessages(getMembersMeMessagesParams)
    .then((result) => {
      this.hasMessage = false;
      if (result.length > 0) {
        this.showTheme = true;
        result.reverse();
        let message = result.shift();
        this.hasMessage = true;
        this.messageId = message['id'];
        this.message = message['data']['message'];
        this.initMessage = this.message;
        this.displayYear = moment(message['createdAt']).format('YYYY');
        this.displayMonth = moment(message['createdAt']).format('MM');
        this.displayDate = moment(message['createdAt']).format('DD');
      }
      // メッセージが取得できなかった場合、メッセージ表示領域自体を非表示にする
      if (!this.hasMessage) {
        this.showTheme = false;
      }
      this.$scope.$apply();
    })
    .catch((error) => {
      // エラー発生時、テーマを非表示に
      this.showTheme = false;
      this.$scope.$apply();
      console.log('error : ', error);
    });
  }

  create () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    if (this.validatePersonalCard()) {
      this.commonFactory.overlayHidden();
      return;
    }

    let params = {memberId: this.targetId};
    let bodies = {type: 1, data: {message: $('#txtMessage').val(), isUnpublished: true}};
    this.commonApiFactory.postMembersMemberIdMessages(params, bodies)
    .then((message) => {
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
      this.openDialog('公開予定の個人テーマを新規設定しました。');
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  update () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    if (this.validatePersonalCard()) {
      this.commonFactory.overlayHidden();
      return;
    }

    this.draftMessage = $('#txtMessage').val();
    let params = { memberId: this.targetId };
    let bodies = { id: this.draftMessageId, data: { message: this.draftMessage } };
    this.commonApiFactory.putMembersMemberIdMessages(params, bodies)
    .then((message) => {
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
      this.openDialog('公開予定の個人テーマの編集が完了しました。');
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  publish () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    let params = { memberId: this.targetId };
    let bodies = { id: this.draftMessageId, data: { isUnpublished: false } };
    this.commonApiFactory.putMembersMemberIdMessages(params, bodies)
    .then((message) => {
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
      this.openDialog('個人テーマが公開されました。');
    })
    .catch((error) => {
      console.log('error : ', error);
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_UNEXPECTED_ERROR, 5000, false);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });
  }

  validatePersonalCard () {
    let str = $('#txtMessage').val();
    if (!str) {
      this.changeErrorMessage(true, false, false);
    } else if (str.length > 1000) {
      // this.changeErrorMessage(false, true, false)
      this.changeErrorMessage(false, false, false);
      return false;
    } else if (this.commonFactory.isProhibitionChars(str)) {
      // this.changeErrorMessage(false, false, true);
      this.changeErrorMessage(false, false, false);
      return false;
    } else {
      this.changeErrorMessage(false, false, false);
      return false;
    }
    return true;
  }

  changeErrorMessage (empty, overLength, prohibitionChars) {
    this.validationForPersonalCard.isEmpty = empty;
    this.validationForPersonalCard.isOverLength = overLength;
    this.validationForPersonalCard.isProhibitionChars = prohibitionChars;
  }

  enterCreateMode () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.message = '';
    this.editMode = true;
    this.isCreateMode = true;
  }

  enterUpdateMode () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.editMode = true;
    this.isUpdateMode = true;
  }

  cancelMode () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    location.reload();
  }

  openDialog (message) {
    this.isDialogOpened = true;
    this.dialogMessage = message;
  }

  closeDialog () {
    this.isDialogOpened = false;
    location.reload();
  }
}

angular.module('myApp').component(COMPONENT_NAME,
  {
    bindings: {
      name: '@' + COMPONENT_NAME,
      showTheme: '=showtheme',
      themeViewAll: '=themeviewall',
      coachView: '=coachview',
      editMode: '=editmode'
    },
    controller: PersonalCardController,
    templateUrl: 'app/components/personal-card/personal-card.html'
  });




// WEBPACK FOOTER //
// ./app/components/personal-card/personal-card-controller.es6